import { gql } from 'graphql-tag'

import { FRAGMENT_CONVERSATION_HEADER_CONVERSATION } from './ConversationHeader.hasura'
import {
  FRAGMENT_CONVERSATION_TYPING_STATUS_CONVERSATION,
  FRAGMENT_CONVERSATION_TYPING_STATUS_MESSAGE,
} from './ConversationTypingStatus.hasura'
import { FRAGMENT_CONVERSATION_USERS_SEEN_CONVERSATION_USER } from './ConversationUsersSeen.hasura'
import { FRAGMENT_MESSAGE_MESSAGE } from './Message.hasura'
import { FRAGMENT_NEW_MESSAGE_CONVERSATION } from './NewMessage.hasura'

export const FRAGMENT_CONVERSATION_SINGLE_CONVERSATION = gql`
  fragment ConversationSingleConversation on conversation {
    ...ConversationHeaderConversation
    ...ConversationTypingStatusConversation
    ...NewMessageConversation

    id
    closed_at
    conversation_users {
      ...ConversationUsersSeenConversationUser

      last_read_at
      user {
        id
      }
    }
  }
  ${FRAGMENT_CONVERSATION_HEADER_CONVERSATION}
  ${FRAGMENT_CONVERSATION_TYPING_STATUS_CONVERSATION}
  ${FRAGMENT_NEW_MESSAGE_CONVERSATION}
  ${FRAGMENT_CONVERSATION_USERS_SEEN_CONVERSATION_USER}
`

export const FRAGMENT_CONVERSATION_SINGLE_MESSAGE = gql`
  fragment ConversationSingleMessage on message {
    ...MessageMessage
    ...ConversationTypingStatusMessage

    id
    client_id
    body_safe
    created_at
  }
  ${FRAGMENT_MESSAGE_MESSAGE}
  ${FRAGMENT_CONVERSATION_TYPING_STATUS_MESSAGE}
`
